import { Component, OnInit } from '@angular/core';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';

import { LayoutComponent } from '../layout/layout.component';
import { MenuItem, RouteService } from '../services/route.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  menuItems: MenuItem[];

  constructor(
    private routeService: RouteService,
    private location: Location
  ) { }

  ngOnInit() {
    this.menuItems = this.routeService.mainMenu();
  }

  isMobileMenu(): boolean {
    return LayoutComponent.isMobileMenu();
  }

  getPath() {
    return this.location.prepareExternalUrl(this.location.path());
  }

}



// WEBPACK FOOTER //
// /builds/iws/vanenet/src/app/main/sidebar/sidebar.component.ts